export const environment = {
  production: false,
  appUrl: "https://seva-qualiti.firebaseapp.com",
  api: {
    url: "https://us-central1-seva-qualiti.cloudfunctions.net/api",
    auth: {
      client_id: "4dd939d8bc2ffea579b9a7abf3dfcd72",
      client_secret: "3321cd73b78c55797a6d5399e7bf3e27aaa310655b6cb4dd0d2e7f13f7989592",
      scopes: "ViewUser,ModifyUser,ViewApplication,ModifyApplication,ViewCompany,ModifyCompany,ViewProject,ModifyProject,ViewTestRun,ModifyTestRun,ViewTestCase,ModifyTestCase,ViewBug,ModifyBug,ViewScheduledRun,ModifyScheduledRun"
    }
  },
  stripeKey: "pk_test_jHk2fwzfnPBVuXb8G0acfpr9",
  firebase: {
    apiKey: "AIzaSyCPoY7e8uM3EiIvissv77cfcLYmJFYWDuc",
    authDomain: "seva-qualiti.firebaseapp.com",
    databaseURL: "https://seva-qualiti.firebaseio.com",
    projectId: "seva-qualiti",
    storageBucket: "seva-qualiti.appspot.com",
    messagingSenderId: "589953392742",
    appId: "1:589953392742:web:37ebc4388620e9e2aa0da7",
    measurementId: "G-YFV2Z9ES23"
  },
  envName: "seva-qualiti",
  adminUid: "VE6cV6Cwm3atn5z53ybkCBaXEiH2",
  scheduledRunsAdminUid: "MpyaAAOQ6yRMNxGWlAMDSy75w7n1",
  projectAdminUid: "qh0d2Wx3kXYFkPSJKNFJ7nNec592",
  developerUid: "VE6cV6Cwm3atn5z53ybkCBaXEiH2",
  billingAdminUid: "VE6cV6Cwm3atn5z53ybkCBaXEiH2",
  testerUid: "gHbJFyqAWbaywXe2jdzxFrDg2ME3",
  captainUid: "sV9ZLjzA6xQyAIHgZEvvwhdcR5k2",
  seniorUid: "I0t3PYkT4zSAKzZy4r0JGe1YTnm2",
  superUid: "Tf74yQBx3phrhpAjOu34TX7YM2g2"
}
